import { useField, useWizardService } from '@kizi/comparator-core';
import { Button, ButtonProps, Div } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import React, { useCallback } from 'react';

type GoToButtonProps = ButtonProps & {
  index: number;
  registerAnalyticsRemoveFromCartEvent?: any;
  withIcon?: boolean;
};

export const GoToButton: React.FC<GoToButtonProps> = ({
  children,
  index,
  withIcon = false,
  ...buttonProps
}) => {
  const wizard = useWizardService();
  const onClickHandler = useCallback(
    () => wizard?.send({ type: 'GOTO', index }),
    [wizard, index],
  );

  if (!wizard) return null;

  let currentStep = wizard?.getSnapshot()?.context?.currentStepIndex;

  let divVariant = 'lightTabViewTab';
  if (buttonProps?.variant === 'applyPageNavigation') {
    if (index === currentStep) {
      divVariant = 'lightTabViewTabSelected';
    }
  }

  return buttonProps?.variant === 'applyPageNavigation' ? (
    <Div
      onClick={onClickHandler}
      variant={divVariant}
      style={{ cursor: index >= currentStep ? 'text' : 'pointer' }}
    >
      {children}
    </Div>
  ) : (
    <Button
      onClick={onClickHandler}
      {...buttonProps}
      display={'flex'}
      alignItems={'center'}
    >
      {withIcon && (
        <IconV2 height={20} mr={2} my="auto" name="big-arrow-left" width={20} />
      )}
      {children}
    </Button>
  );
};

export const GoToButtonIcon: React.FC<GoToButtonProps> = ({
  children,
  index,
  registerAnalyticsRemoveFromCartEvent,
  ...buttonProps
}) => {
  const wizard = useWizardService();
  const selectedProductField = useField('selectedProduct');
  const parsedFieldValue = JSON.parse(
    (selectedProductField?.value as string) || '{}',
  );

  const onClickHandler = useCallback(() => {
    if (registerAnalyticsRemoveFromCartEvent) {
      registerAnalyticsRemoveFromCartEvent(parsedFieldValue);
    }
    wizard?.send({ type: 'GOTO', index });
  }, [wizard, index]);

  if (!wizard) return null;

  return (
    <Button display="flex" onClick={onClickHandler} {...buttonProps}>
      <IconV2 height={20} mr={2} my="auto" name="big-arrow-left" width={20} />
      {children}
    </Button>
  );
};
